import React from 'react';
import PropTypes from 'prop-types';
import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';
import closeIcon from 'images/close.svg';
import hamburgerIcon from 'images/hamburger.svg';

const dumbNavigation = dumbBem('landing-nav');
const BurgerImg = tx([{ element: 'burger' }, dumbNavigation])('img');

const Burger = ({
  isOpened,
  onClick,
}) => {
  const activeIcon = isOpened ? closeIcon : hamburgerIcon;

  return (
    <BurgerImg
      src={activeIcon}
      alt="Close Icon"
      onClick={onClick}
      data-test="button"
    />
  );
};

Burger.propTypes = {
  isOpened: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

Burger.defaultProps = {
  isOpened: false,
};

export default Burger;



// WEBPACK FOOTER //
// ./src/components/landing/components/navigation/Burger.js